export * from './deepEqual'
export * from './shallowEqual'
